// Helper function to simplify how config and override callbacks are provided.
export const customizePlugin = ({ assetPlugin, config, overrideCallback, }) => ({
    ...assetPlugin,
    createAsset: (options) => {
        return assetPlugin.createAsset({
            ...options,
            config: { ...options.config, ...config }, // `options.config` comes from the assetsModule config.
            overrideCallback,
        });
    },
});
